var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.1913H7.75003C3.63336 19.1913 1.88336 17.433 1.88336 13.3247V9.58301C1.88336 9.24134 2.1667 8.95801 2.50836 8.95801C2.85003 8.95801 3.13336 9.24134 3.13336 9.58301V13.3247C3.13336 16.733 4.34169 17.9413 7.75003 17.9413H12.2417C15.65 17.9413 16.8584 16.733 16.8584 13.3247V9.58301C16.8584 9.24134 17.1417 8.95801 17.4834 8.95801C17.825 8.95801 18.1084 9.24134 18.1084 9.58301V13.3247C18.1167 17.433 16.3584 19.1913 12.25 19.1913Z",
    fill: "url(#paint0_linear_1505_16268)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.8577C9.08331 10.8577 8.24998 10.4994 7.65831 9.84108C7.06665 9.18275 6.79165 8.32441 6.88331 7.40775L7.44165 1.84108C7.47498 1.52441 7.74165 1.27441 8.06665 1.27441H11.9583C12.2833 1.27441 12.55 1.51608 12.5833 1.84108L13.1416 7.40775C13.2333 8.32441 12.9583 9.18275 12.3666 9.84108C11.75 10.4994 10.9166 10.8577 9.99998 10.8577ZM8.62498 2.52441L8.12498 7.53275C8.06665 8.09108 8.23331 8.61608 8.58331 8.99941C9.29165 9.78275 10.7083 9.78275 11.4166 8.99941C11.7666 8.60775 11.9333 8.08275 11.875 7.53275L11.375 2.52441H8.62498Z",
    fill: "url(#paint1_linear_1505_16268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2583 10.8577C13.5666 10.8577 12.0583 9.49108 11.8833 7.80775L11.3 1.96608C11.2833 1.79108 11.3416 1.61608 11.4583 1.48275C11.575 1.34941 11.7416 1.27441 11.925 1.27441H14.4666C16.9166 1.27441 18.0583 2.29941 18.4 4.81608L18.6333 7.13275C18.7333 8.11608 18.4333 9.04941 17.7916 9.75775C17.15 10.4661 16.25 10.8577 15.2583 10.8577ZM12.6166 2.52441L13.1333 7.68275C13.2416 8.72441 14.2083 9.60775 15.2583 9.60775C15.8916 9.60775 16.4583 9.36608 16.8666 8.92441C17.2666 8.48275 17.45 7.89108 17.3916 7.25775L17.1583 4.96608C16.9 3.08275 16.2916 2.52441 14.4666 2.52441H12.6166Z",
    fill: "url(#paint2_linear_1505_16268)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70002 10.8577C3.70835 10.8577 2.80835 10.4661 2.16668 9.75775C1.52502 9.04941 1.22502 8.11608 1.32502 7.13275L1.55002 4.84108C1.90002 2.29941 3.04168 1.27441 5.49168 1.27441H8.03335C8.20835 1.27441 8.37502 1.34941 8.50002 1.48275C8.62502 1.61608 8.67502 1.79108 8.65835 1.96608L8.07502 7.80775C7.90002 9.49108 6.39168 10.8577 4.70002 10.8577ZM5.49168 2.52441C3.66668 2.52441 3.05835 3.07441 2.79168 4.98275L2.56668 7.25775C2.50002 7.89108 2.69168 8.48275 3.09168 8.92441C3.49168 9.36608 4.05835 9.60775 4.70002 9.60775C5.75002 9.60775 6.72502 8.72441 6.82502 7.68275L7.34168 2.52441H5.49168Z",
    fill: "url(#paint3_linear_1505_16268)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 19.1911H7.91669C7.57502 19.1911 7.29169 18.9077 7.29169 18.5661V16.4827C7.29169 14.7327 8.25002 13.7744 10 13.7744C11.75 13.7744 12.7084 14.7327 12.7084 16.4827V18.5661C12.7084 18.9077 12.425 19.1911 12.0834 19.1911ZM8.54169 17.9411H11.4584V16.4827C11.4584 15.4327 11.05 15.0244 10 15.0244C8.95002 15.0244 8.54169 15.4327 8.54169 16.4827V17.9411Z",
    fill: "url(#paint4_linear_1505_16268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1505_16268",
    x1: 1.88336,
    y1: 8.95801,
    x2: 19.0702,
    y2: 10.9682,
    gradientUnits: "userSpaceOnUse",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1505_16268",
    x1: 6.86603,
    y1: 1.27441,
    x2: 13.6073,
    y2: 1.60097,
    gradientUnits: "userSpaceOnUse",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1505_16268",
    x1: 11.2972,
    y1: 1.27441,
    x2: 19.1695,
    y2: 1.72012,
    gradientUnits: "userSpaceOnUse",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1505_16268",
    x1: 1.30615,
    y1: 1.27441,
    x2: 9.17882,
    y2: 1.72015,
    gradientUnits: "userSpaceOnUse",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1505_16268",
    x1: 7.29169,
    y1: 13.7744,
    x2: 13.0765,
    y2: 14.2012,
    gradientUnits: "userSpaceOnUse",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.09af03380bd337eeb0400d2eec1fbba1.svg";
export { ForwardRef as ReactComponent };